import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalizedString, Locale } from './ngrx/tile/tile.service';

@Pipe({ name: 'localizedString' })
export class LocalizedStringPipe implements PipeTransform {
  private translate = inject(TranslateService);


  transform(value: any, ...args: string[]): any {
    const attributeName = args.pop();

    const currentLang = this.translate.currentLang() === 'en-US' ? 'en' : 'de';
    const localizedAttribute = value[attributeName].find(
      (localizedString: LocalizedString) => localizedString.locale === Locale[currentLang]
    );

    return localizedAttribute.value;
  }
}
